import type { ConfigObjectMatch, ContentUpdateResult } from '@cli-types/next-adapter/init.js'
import { findTopLevelProperty } from './find-top-level-property.js'

export function upsertTopLevelBooleanProperty(
  content: string,
  configObject: ConfigObjectMatch,
  propertyName: string
): ContentUpdateResult {
  const existingProp = findTopLevelProperty(
    content,
    configObject.start,
    configObject.end,
    propertyName
  )

  if (existingProp) {
    if (existingProp.value.trim() === 'true') {
      return { content, changed: false }
    }

    return {
      content: `${content.slice(0, existingProp.valueStart)}true${content.slice(existingProp.valueEnd)}`,
      changed: true
    }
  }

  return {
    content:
      content.slice(0, configObject.start + 1) +
      `\n${configObject.propertyIndent}${propertyName}: true,` +
      content.slice(configObject.start + 1),
    changed: true
  }
}
